import mediumZoom from 'medium-zoom';

export default function(query: string): any {
  return mediumZoom(Array.from(document.querySelectorAll(query)).filter(
    (c) => c.parentElement && c.parentElement.tagName !== 'A',
  ) as any);
}
